import * as React from 'react'
import { ReactElement, useEffect } from 'react'
import { baseListStyles } from '../../../List/BaseList'
import { Stack, Text } from '@fluentui/react'
import MoneyText from '../../../Text/Currency/MoneyText'
import { FileSurchargeDto } from './FileSurchargeList'
import useSurchargeType from '../../../../hooks/useSurchargeType'
import { SurchargeValueType } from '../../../../config/i18nConfig'
import useCurrency from '../../../../hooks/useCurrency'
import { formatDecimals } from '../../../../helpers/numberHelper'

export type SurchargeListItemProps = {
    index: number
    item: FileSurchargeDto
    edit: (index: number) => void
}

export function FileSurchargeListItem(props: SurchargeListItemProps): ReactElement {
    const { surchargeType } = useSurchargeType(props.item.surchargeType)
    const { currency, setAlpha: setCurrencyAlpha } = useCurrency()

    useEffect(() => {
        if (surchargeType) {
            setCurrencyAlpha(surchargeType.currency.alpha)
        }
    }, [surchargeType])

    return (
        <Stack horizontal styles={{ root: baseListStyles.itemCell }} onClick={() => props.edit(props.index)}>
            <Stack horizontal={false} style={{ flexGrow: 1, minWidth: 0 }} tokens={{ childrenGap: 's2' }}>
                <Text style={{ flexGrow: 1, minWidth: 0 }}>{props.item.name}</Text>
            </Stack>
            <Stack horizontal={false} horizontalAlign={'end'} tokens={{ childrenGap: 's2' }}>
                {surchargeType?.valueType === SurchargeValueType.Fixed && (
                    <MoneyText amount={props.item.value} currency={currency} />
                )}
                {surchargeType?.valueType === SurchargeValueType.Percentage && (
                    <Text>{`${formatDecimals(props.item.value || 0, 2, 'en', 'nl-nl', false)} %`}</Text>
                )}
            </Stack>
        </Stack>
    )
}
